module.exports = __webpack_public_path__ + "img/beatriz.0e017a2a.jpg";